import type React from 'react'

import { Checkbox } from '@components/ui/Checkbox'

import { FilterFormFormControlLabel } from '@components/filters/PageFilterBars/styles'
import { ChoicesWrapper } from '../styles'

interface MultiCheckboxFilterProps {
  values: CommonIdAndNameType[]
  onChange: (values: CommonIdAndNameType[]) => void
  config: { name: string; options: CommonIdAndNameType[] }
}

// TODO this component should match with FilterSelect:FormFilterSelect - checkbox variant
export default function MultiCheckboxFilter({ config: { options }, onChange, values }: MultiCheckboxFilterProps) {
  function handleChange(option: CommonIdAndNameType) {
    return function handler(event: React.ChangeEvent<HTMLInputElement>) {
      if (event.target.checked) {
        onChange([...values, option])
      } else {
        onChange(values.filter(({ id }) => id !== option.id))
      }
    }
  }

  return (
    <ChoicesWrapper>
      {options.map(option => (
        <FilterFormFormControlLabel
          checked={Boolean(values.find(value => value.id === option.id))}
          control={<Checkbox />}
          gap={10}
          key={option.id}
          label={option.name}
          onChange={handleChange(option)}
        />
      ))}
    </ChoicesWrapper>
  )
}
